<template>
    <z-page title="Semak Hak Milik" :append-button="true">
        <w-flex class="justify-end">
            <div class="xs4 mr3">
                <w-select
                    class="mb3 daerah"
                    :items="districts"
                    v-model="form.kod_daerah"
                    outline
                    label="Pilih Daerah"
                    label-position="left"
                    @input="$emit('onDaerahChange')"
                >
                </w-select>
            </div>
        </w-flex>
        <w-form @success="emit('onSemak', form)">
            <w-flex class="mt3" v-show="byBarcode">
                <div class="xs2">
                    <w-radio
                        class="mr2"
                        v-model="form.form_option"
                        name="radio"
                        return-value="option1"
                    >
                        Barcode / No. Akaun
                    </w-radio>
                </div>
                <div class="xs10 mr3">
                    <w-input
                        v-model="form.barcode"
                        placeholder="Sila Masukkan Barcode"
                        :disabled="form.form_option !== 'option1'"
                        :validators="[validators.required]"
                        maxlength="28"
                    ></w-input>
                </div>
            </w-flex>
            <w-flex class="mt3" v-show="byIdHM">
                <div class="xs2 mr3">
                    <w-radio
                        v-model="form.form_option"
                        name="radio"
                        return-value="option2"
                    >
                        ID Hakmilik
                    </w-radio>
                </div>
                <div class="xs2 mr3">
                    <w-select
                        :validators="[validators.required]"
                        placeholder="Sila Pilih Kod Mukim"
                        v-model="form.kod_mukim"
                        :items="mukim"
                        value="01"
                        :disabled="form.form_option !== 'option2'"
                    />
                </div>
                <div class="xs2 mr3">
                    <w-select
                        :validators="[validators.required]"
                        placeholder="Sila Pilih Jenis Hakmilik"
                        v-model="form.kod_jenis_hm"
                        :items="jhm"
                        :disabled="form.form_option !== 'option2'"
                    />
                </div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_hm"
                        :model-value="
                            form.form_option !== 'option2' ? '' : form.no_hm
                        "
                        placeholder="Sila Masukkan No. Hakmilik"
                        :disabled="form.form_option !== 'option2'"
                        :validators="[
                            form.form_option === 'option2'
                                ? validators.required
                                : null,
                        ]"
                    >
                    </w-input>
                </div>

                <div class="xs2 mr3"></div>
                <div class="xs2 mr3"></div>
            </w-flex>
            <w-flex class="mt3" v-show="byIdHM">
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_bangunan"
                        :model-value="
                            form.form_option !== 'option2'
                                ? ''
                                : form.no_bangunan
                        "
                        placeholder="Bangunan"
                        :disabled="form.form_option !== 'option2'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_tingkat"
                        :model-value="
                            form.form_option !== 'option2'
                                ? ''
                                : form.no_tingkat
                        "
                        placeholder="Tingkat"
                        :disabled="form.form_option !== 'option2'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_petak"
                        :model-value="
                            form.form_option !== 'option2' ? '' : form.no_petak
                        "
                        placeholder="Petak"
                        :disabled="form.form_option !== 'option2'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3"></div>
            </w-flex>

            <w-flex class="mt3" v-show="byMukimNoHM">
                <div class="xs2 mr3">
                    <w-radio
                        v-model="form.form_option"
                        name="radio"
                        return-value="option3"
                    >
                        Mukim dan No. Hakmilik
                    </w-radio>
                </div>
                <div class="xs2 mr3">
                    <w-select
                        :validators="[
                            form.form_option === 'option3'
                                ? validators.required
                                : null,
                        ]"
                        placeholder="Sila Pilih Kod Mukim"
                        v-model="form.kod_mukim"
                        :model-value="
                            form.form_option !== 'option3' ? '' : form.kod_mukim
                        "
                        :items="mukim"
                        :disabled="form.form_option !== 'option3'"
                    />
                </div>
                <div class="xs2 mr3">
                    <w-input
                        :validators="[
                            form.form_option === 'option3'
                                ? validators.required
                                : null,
                        ]"
                        v-model="form.no_hm"
                        :model-value="
                            form.form_option !== 'option3' ? '' : form.no_hm
                        "
                        placeholder="Sila Masukkan No. Hakmilik"
                        :disabled="form.form_option !== 'option3'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3"></div>
            </w-flex>
            <w-flex class="mt3" v-show="byMukimNoHM">
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_bangunan"
                        :model-value="
                            form.form_option !== 'option3'
                                ? ''
                                : form.no_bangunan
                        "
                        placeholder="Bangunan"
                        :disabled="form.form_option !== 'option3'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_tingkat"
                        :model-value="
                            form.form_option !== 'option3'
                                ? ''
                                : form.no_tingkat
                        "
                        placeholder="Tingkat"
                        :disabled="form.form_option !== 'option3'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_petak"
                        :model-value="
                            form.form_option !== 'option3' ? '' : form.no_petak
                        "
                        placeholder="Petak"
                        :disabled="form.form_option !== 'option3'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3"></div>
            </w-flex>

            <w-flex class="mt3" v-show="byJenisNoHM">
                <div class="xs2 mr3">
                    <w-radio
                        v-model="form.form_option"
                        name="radio"
                        return-value="option4"
                    >
                        Jenis dan No. Hakmilik
                    </w-radio>
                </div>
                <div class="xs2 mr3">
                    <w-select
                        :validators="[
                            form.form_option === 'option4'
                                ? validators.required
                                : null,
                        ]"
                        placeholder="Sila Pilih Jenis Hakmilik"
                        v-model="form.kod_jenis_hm"
                        :model-value="
                            form.form_option !== 'option4'
                                ? ''
                                : form.kod_jenis_hm
                        "
                        :items="jhm"
                        :disabled="form.form_option !== 'option4'"
                    />
                </div>
                <div class="xs2 mr3">
                    <w-input
                        :validators="[
                            form.form_option === 'option4'
                                ? validators.required
                                : null,
                        ]"
                        v-model="form.no_hm"
                        :model-value="
                            form.form_option !== 'option4' ? '' : form.no_hm
                        "
                        placeholder="Sila Masukkan No. Hakmilik"
                        :disabled="form.form_option !== 'option4'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3"></div>
            </w-flex>
            <w-flex class="mt3" v-show="byJenisNoHM">
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_bangunan"
                        :model-value="
                            form.form_option !== 'option4'
                                ? ''
                                : form.no_bangunan
                        "
                        placeholder="Bangunan"
                        :disabled="form.form_option !== 'option4'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_tingkat"
                        :model-value="
                            form.form_option !== 'option4'
                                ? ''
                                : form.no_tingkat
                        "
                        placeholder="Tingkat"
                        :disabled="form.form_option !== 'option4'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3">
                    <w-input
                        v-model="form.no_petak"
                        :model-value="
                            form.form_option !== 'option4'
                                ? ''
                                : form.no_tingkat
                        "
                        placeholder="Petak"
                        :disabled="form.form_option !== 'option4'"
                    >
                    </w-input>
                </div>
                <div class="xs2 mr3"></div>
                <div class="xs2 mr3"></div>
            </w-flex>
            <div class="d-flex justify-end mt3">
                <w-button class="my1 mr0" type="submit" :loading="searching">
                    Semak
                </w-button>
            </div>
        </w-form>
    </z-page>
</template>

<script>
import { ref, defineComponent, onMounted, watch } from "vue";
export default defineComponent({
    props: {
        searching: {
            type: Boolean,
            default: false,
        },
        byBarcode: {
            type: Boolean,
            default: true,
        },
        byIdHM: {
            type: Boolean,
            default: true,
        },
        byMukimNoHM: {
            type: Boolean,
            default: true,
        },
        byJenisNoHM: {
            type: Boolean,
            default: true,
        },
        searching: {
            type: Boolean,
            default: false,
        },
        form: Object,
        districts: {
            type: Array,
            default: [{ label: "Loading", selected: true }],
        },
        mukim: { type: Array, default: [{ label: "Loading", selected: true }] },
        jhm: { type: Array, default: [{ label: "Loading", selected: true }] },
    },
    emits: ["onSemak", "onDaerahChange"],
    setup(props, { emit }) {
        const validators = ref({
            required: (value) => !!value || "Sila Isi Ruangan Ini",
        });

        return {
            validators,
            emit,
        };
    },
});
</script>
<style>
    div.w-menu.w-select__menu.w-menu--bottom.w-menu--align-left{
        z-index: 500;
    }
</style>
